import { MessageService } from "./../services/message.service";
import { Message } from "./../common/message";
import { WorkshopService } from "./../services/workshop.service";

import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { WorkShop } from "./../models/workshop";
import { MatDialog } from "@angular/material";
import { ConfirmDeleteDialogComponent } from "../dialog/confirm-delete-dialog/confirm-delete-dialog.component";

let ELEMENT_DATA = [];

@Component({
  selector: "app-workshop",
  templateUrl: "./workshop.component.html",
  styleUrls: ["./workshop.component.scss"],
})
export class WorkshopComponent implements OnInit {
  form: FormGroup;
  submitted = false;
  success = false;
  ELEMENT_DATA: any[];
  displayedColumns: string[] = [
    "SN",
    "name",
    "tel",
    "manager",
    "address",
    "actions",
  ];
  dataSource = new MatTableDataSource();

  @ViewChild(MatPaginator) paginator: MatPaginator;

  isFormDisplay: boolean = false;
  isAddNew: boolean = true;
  workShop: any;

  constructor(
    private dialog: MatDialog,
    private service: WorkshopService,
    private formBuilder: FormBuilder,
    private msg: MessageService
  ) {}

  ngOnInit() {
    this.workShop = new WorkShop();
    this.setMessageForm();
    this.getWorkShops();
  }

  setMessageForm() {
    this.form = this.formBuilder.group({
      name: ["", Validators.required],
      tel: ["", Validators.required],
      manager: ["", Validators.required],
      address: ["", Validators.required],
    });
  }

  getWorkShops() {
    ELEMENT_DATA = [];
    this.service.getAll().subscribe((result) => {
      ELEMENT_DATA = ELEMENT_DATA.concat(result);
      this.updateDataSource();
    });
  }

  updateDataSource() {
    this.dataSource = new MatTableDataSource<any>(ELEMENT_DATA);
    this.dataSource.paginator = this.paginator;
  }

  displayForm() {
    this.workShop = new WorkShop();
    this.isFormDisplay = true;
  }

  displayTable() {
    this.isFormDisplay = false;
    this.resetForm();
  }

  onSave(
    name: HTMLDataElement,
    tel: HTMLDataElement,
    manager: HTMLDataElement,
    address: HTMLDataElement
  ) {
    this.submitted = true;

    if (this.form.controls.name.errors) {
      return;
    }

    if (this.workShop.id) {
      this.updateElement(name, tel, manager, address);
    } else {
      this.addElement(name, tel, manager, address);
    }
  }

  resetForm(ret?: boolean) {
    this.form.reset();
    this.submitted = false;
    if (ret) this.isFormDisplay = false;
  }

  addElement(name, tel, manager, address) {
    this.workShop.setName(name.value);
    this.workShop.setTel(tel.value);
    this.workShop.setManager(manager.value);
    this.workShop.setAddress(address.value);

    this.service.create(this.workShop).subscribe((result) => {
      this.msg.alert(Message.SAVE);
      ELEMENT_DATA.push(result);
      this.updateDataSource();
      this.workShop = new WorkShop();
      this.resetForm();
    });
  }

  updateElement(name, tel, manager, address) {
    this.workShop.setName(name.value);
    this.workShop.setTel(tel.value);
    this.workShop.setManager(manager.value);
    this.workShop.setAddress(address.value);

    this.service.update(this.workShop).subscribe((result) => {
      this.msg.alert(Message.UPDATE);
      ELEMENT_DATA.forEach((elem, index) => {
        if (elem.id === this.workShop.id) {
          ELEMENT_DATA.splice(index, 1, result);
          return;
        }
      });

      this.updateDataSource();
      this.workShop = new WorkShop();
      this.resetForm(true);
    });
  }

  editElement(ele) {
    this.isFormDisplay = true;
    this.isAddNew = false;
    this.workShop = ele;
    this.workShop = new WorkShop();
    this.workShop.setId(ele.id);
    this.workShop.setName(ele.name);
    this.workShop.setTel(ele.tel);
    this.workShop.setAddress(ele.address);
    this.workShop.setManager(ele.manager);
    this.form.controls.name.setValue(ele.name);
    this.form.controls.manager.setValue(ele.manager);
    this.form.controls.tel.setValue(ele.tel);
    this.form.controls.address.setValue(ele.address);
  }

  deleteElement(ele) {
    this.dialog
      .open(ConfirmDeleteDialogComponent)
      .afterClosed()
      .subscribe((result) => {
        if (result === "true") {
          this.service.delete(ele.id).subscribe((result) => {
            this.msg.alert(Message.DELETE);
            let index = ELEMENT_DATA.indexOf(ele);
            ELEMENT_DATA.splice(index, 1);
            this.updateDataSource();
          });
        } else {
          return;
        }
      });
  }
}
